import React from 'react';

import { Button, Group, LoadingOverlay, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteOtherWorkEvent from 'hooks/otherWorkEvent/useDeleteOtherWorkEvent';
import { PayrollEventRetrieve } from 'types';
import notificationHandler from 'utils/notifications';

interface IModalOtherWorkEventDeleteProps {
  opened: boolean;
  handleClose: () => void;
  payrollEvent?: PayrollEventRetrieve;
}

const ModalOtherWorkEventDelete = ({
  opened,
  payrollEvent,
  handleClose,
}: IModalOtherWorkEventDeleteProps): JSX.Element => {
  const { mutate, isLoading } = useDeleteOtherWorkEvent();
  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (payrollEvent) {
      mutate(payrollEvent.genesisEventId, {
        onSuccess: () => {
          successNotification(
            'Other work event delete success',
            `${payrollEvent.genesisEventName} successfully deleted.`,
          );
        },
        onError: error => {
          errorNotification('Other work event delete failed', error.response?.data.message);
        },
        onSettled: () => {
          handleClose();
        },
      });
    }
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Other Work Event</Title>}
      size='auto'
    >
      <LoadingOverlay visible={!payrollEvent || isLoading} />
      <Stack>
        <Text>{`Are you sure you want to delete ${payrollEvent?.genesisEventName}?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            loading={!payrollEvent || isLoading}
            data-cy='otherWorkEventDeleteButton'
          >
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalOtherWorkEventDelete;
